import { ErrorMessageContents } from '../../helpers/hub'
import { Customer } from './types'

export const customerFetch = () => ({ type: 'customers.fetch' } as const)
type CustomerFetchAction = ReturnType<typeof customerFetch>

export const customerAddCustomer = (customers: Customer[]) =>
  ({ type: 'customers.addCustomers', payload: customers } as const)
type CustomerAddCustomerAction = ReturnType<typeof customerAddCustomer>

export const customerFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'customers.fetchFail', payload: error, error: true } as const)
type CustomerFetchFailAction = ReturnType<typeof customerFetchFail>

export type CustomersAction =
  | CustomerFetchAction
  | CustomerAddCustomerAction
  | CustomerFetchFailAction
